import { useMutation, useQuery } from "@tanstack/react-query";
import {
  EditProfile,
  MyProfile,
  ProfileMatch,
  SimiliarMatches,
  updateUserPhoto,
} from "api/profile";
import AlertNotification from "components/CustomWidgets/alertNotification";

export const useMyProfile = (reference_id, options = {}) => {
  return useQuery({
    queryKey: ["my-profile", { reference_id }],
    queryFn: MyProfile,
    ...options,
  });
};

export const useProfileMatch = (user_id, options = {}) => {
  return useQuery({
    queryKey: ["profileMatch", { user_id }],
    queryFn: ProfileMatch,
    ...options,
    enabled: !!user_id,
  });
};

export const useSimiliarMatches = (
  { page, limit, see_all, profile_id },
  options = {},
) => {
  return useQuery({
    queryKey: ["similiarMatches", { page, limit, see_all, profile_id }],
    queryFn: SimiliarMatches,
    ...options,
  });
};

export const useEditProfile = () => {
  return useMutation({
    mutationFn: EditProfile,
    onSuccess: (data) => {
      AlertNotification("success", "Data updated successfully!");
    },
  });
};

export const useUpdateUserPhoto = (options = {}) => {
  return useMutation({
    mutationFn: updateUserPhoto,
    onSuccess: (data, variables, context) => {
      options.onSuccess?.(data, variables, context);
    },
  });
};
